<template>
  <div>
    <div class="row">
      <div class="col-12 mb-3">
        <button class="close" @click="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h5>
          {{ title }}
        </h5>
      </div>
    </div>
    <div class="row">
      <AppInput
        v-model="email.recipients"
        :errors="errors"
        class="col-md-12"
        label="Recipients (comma separated)"
        field="recipients"
      />
    </div>
    <div class="row">
      <AppInput
        v-model="email.subject"
        :errors="errors"
        class="col-md-12"
        label="Subject"
        field="subject"
      />
    </div>
    <div class="row">
      <AppTextArea
        v-model="email.message"
        label="Message"
        field="message"
        :errors="errors"
        class="col-12"
      />
    </div>
    <div class="text-right">
      <button @click="sendOrder" class="btn btn-primary">Send</button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppInput from '../form/AppInput';
import AppTextArea from '../form/AppTextarea';
import Errors from '../../utils/errors';
import NotificationService from '../../services/notification.service';

export default {
  props: {},
  components: {
    AppInput,
    AppTextArea,
  },
  data() {
    return {
      errors: new Errors(),
      email: {
        subject: '',
        message: '',
        recipients: '',
      },
    };
  },
  mounted() {
    this.initEmail();
  },
  computed: {
    ...mapGetters({
      order: 'orders/order',
    }),
    ...mapState({
      prevStatus: (state) => state.orders.prevStatus,
      isStatusCodeChanged: (state) => state.orders.isStatusCodeChanged,
    }),
    title() {
      return this.isStatusCodeChanged ? 'Order status changed. Notify parties?' : 'Send order';
    },
  },
  methods: {
    initEmail() {
      this.seedRecipients();
      this.setContent();
    },
    setContent() {
      if (this.isStatusCodeChanged) {
        this.email.subject = `Order ${this.order.number} status changed`;
        this.email.message = 'Your order status has changed.\nPlease see order attached';
      } else {
        this.email.subject = `Order ${this.order.number}`;
        this.email.message = ' Please see order attached.';
      }
    },
    async close() {
      this.$emit('close');
    },
    sendOrder() {
      this.$store
        .dispatch('orders/sendOrder', this.email)
        .then((res) => {
          NotificationService.success(res.message);
          this.close();
        })
        .catch((err) => this.errors.set(err.response.data.errors));
    },
    seedRecipients() {
      const recipients = [];

      if (this.order.logistics_contact_user && this.order.logistics_contact_user.email) {
        recipients.push(this.order.logistics_contact_user.email);
      }
      if (this.order.supplier_contact_user && this.order.supplier_contact_user.email) {
        recipients.push(this.order.supplier_contact_user.email);
      }
      if (this.order.client_contact_user && this.order.client_contact_user.email) {
        recipients.push(this.order.client_contact_user.email);
      }

      if (this.order.order_lines) {
        this.order.order_lines.forEach((orderLine) => {
          if (
            orderLine.receiving_warehouse
            && orderLine.receiving_warehouse.company
            && orderLine.receiving_warehouse.company.email
          ) {
            recipients.push(orderLine.receiving_warehouse.company.email);
          }
        });
      }

      if (this.order.order_lines) {
        this.order.order_lines.forEach((orderLine) => {
          if (
            orderLine.dispatching_warehouse
            && orderLine.dispatching_warehouse.company
            && orderLine.dispatching_warehouse.email
          ) {
            recipients.push(orderLine.dispatching_warehouse.company.email);
          }
        });
      }
      const recipientsSet = new Set(recipients);
      const uniqueRecipients = [...recipientsSet];
      for (let i = 0; i < uniqueRecipients.length; i++) {
        this.email.recipients += `${uniqueRecipients[i]},`;
      }
    },
  },
};
</script>
